import React from 'react';
import { Box } from '@saviynt/design-system';

import FormField from './FormField';
import FormHeader from './FormHeader';
import { type TrackedFormData } from './types';

interface FormBodyState {
  formData: TrackedFormData[];
  setFormData: React.Dispatch<React.SetStateAction<TrackedFormData[]>>;
  level?: number;
}

/**
 * FormBody
 */
function FormBody({ formData, setFormData, level }: FormBodyState) {
  const sectionLength = formData.length;

  if (sectionLength === 0) {
    return null;
  }

  return formData.map((section, index) => {
    const formSectionKey = `form-section-${index}`;
    const isSubsection = Boolean(section.sections !== undefined);

    return (
      <React.Fragment key={formSectionKey}>
        <Box tag='div' className='Form-section'>
          <FormHeader
            title={section.title}
            level={Number(level)}
            index={index}
            isSubsection={isSubsection}
          />
          <Box tag='div' className='Form-section'>
            {section.fields?.map((field) => (
              <FormField
                key={field.name}
                field={field}
                setFormData={setFormData}
                level={Number(level)}
                isNoSection={Boolean(section.sections === undefined)}
              />
            ))}
            {section.sections && (
              <FormBody
                formData={section.sections}
                setFormData={setFormData}
                level={Number(level) + 1}
              />
            )}
          </Box>
        </Box>
        {index < sectionLength - 1 && level === 0 && (
          <hr className='Form-segmentDivider' />
        )}
      </React.Fragment>
    );
  });
}

FormBody.defaultProps = {
  level: 0,
};

export default FormBody;
